<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">إضافة ميزة عقار</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/featuresview">مميزات العقارات</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">إضافة ميزة عقار</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row justify-content-center align-content-center mb-4 mt-5">
          <div class="col-12 col-md-8">
            <h5 class="text-brown me-2">
              <i class="bi bi-clipboard-plus pe-2 text-brown"></i> أضافة ميزة عقار
            </h5>
            <div class="card shadow mb-4">
              <div v-if="hasError" class="text-center pt-3">
                <errorAlert :alertMessage= "message" />
              </div>
              <div v-if="success" class="text-center pt-3">
                <successAlert :message="message" />
              </div>
              <form action="" @submit.prevent="featuresAdd">
                <div class="card-body">
                  <div class="row">
                    <div class="col">
                      <label for="">التصنيف</label>
                      <select class="form-select" v-model="category">
                        <option value="features">مميزات العقار </option>
                        <option value="building_details">تفاصيل المبنى</option>
                        <option value="health_fitness">الصحة واللياقة</option>
                        <option value="places_facilities">الاماكن والمرافق القريبة</option>
                        <option value="entertainment">المرافق والترفيه</option>
                        <option value="services_maintenance">الخدمات والصيانة</option>
                      </select>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6">
                      <div class="form-group py-2">
                        <label>الاسم - عربي:</label>
                        <input type="text" class="form-control" v-model="name" placeholder="الاسم" />
                      </div>
                    </div>
                    <div class="col-12 col-sm-6">
                      <div class="form-group py-2">
                        <label>الاسم - إنجليزي:</label>
                        <input type="text" class="form-control" v-model="nameEn" placeholder="الاسم" />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col">
                      <div class="form-group py-2">
                        <label>الصورة :</label>
                        <input type="file" class="form-control" @change.prevent="onFileLoad($event.target.files)" />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col">
                      <div class="form-group py-2">
                        <label for="">الحاله :</label>
                        <select class="form-control" v-model="status">
                          <option :value="true">نشط</option>
                          <option :value="false">غير نشط</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-footer text-center">
                  <loader  v-if="loading" />
                  <button v-else type="submit" class="btn btn-success">
                    إرسال
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>
<script>
export default {
  name: "featurescreate",
  data(){
    return {
      loading: false,
      hasError: false,
      success: false,
      message: "",
      name: "",
      nameEn: "",
      status: true,
      image: "",
      category: '',
    }
  },
  methods:{
    resetData(){
      this.name = "";
      this.nameEn = "";
      this.image = "";
      this.category = '';
    },
    featuresAdd() {
      this.hasError = false;
      this.loading = true;
      const formData = new FormData();
      formData.append('category',this.category);
      formData.append('name',this.name);
      formData.append('nameEn',this.nameEn);
      formData.append('icon',this.image);
      formData.append('isActive',this.status);
      this.$http.post('/api/admin/propertyFeatures/create',formData).then(res => {
        this.loading = false;
        this.message = 'تم الاضافة بنجاح'
        this.success = true;
        this.resetData();
      }).catch(err => {
        // console.log(err);
        this.message = this.$globalError(err);
        this.hasError = true;
        this.loading = false;
        window.scroll(0,0);
      })
    },
    onFileLoad(files) {
      this.image = files[0];
    }
  }
};
</script>
